import { LocalDate } from "@js-joda/core";
import React from "react";
import { TaskDayTimeParams } from "../../../messages/PatientTasks";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import { CALENDAR_ICON } from "../../../utils/svgs_new";
import { formatDateRange } from "../../../utils/taskUtils";
import { AppIcon } from "../../Generic/AppIcon";
import { AppListItem } from "../../Generic/AppList";
import Flex from "../../Generic/Flex";
import NotesText from "../../Patient/components/NotesText";
import DayTimeParamList from "./DayTimeParamsList";

interface Props {
  dayTimeParams: TaskDayTimeParams;
  startDate: LocalDate;
  dueDate: LocalDate;
}

const AvailableTaskTimeFrame = (props: Props) => {
  const taskDatesRange = React.useMemo(
    () => formatDateRange(props.startDate, props.dueDate),
    [props.startDate, props.dueDate]
  );

  return (
    <AppListItem
      leading={<AppIcon size={16} icon={CALENDAR_ICON} fill="primary" />}
      title={taskDatesRange}
      extra={
        <Flex direction="column">
          <NotesText>{translate(STRINGS.DUE_DATE)}</NotesText>
          <DayTimeParamList dayTimeParams={props.dayTimeParams ?? []} />
        </Flex>
      }
    />
  );
};

export default AvailableTaskTimeFrame;
